import React, { FC } from 'react'
import { Question } from '@dasa-health/alma-icons'
import { Body, Flex, LinkInline } from '@dasa-health/alma-react'
import { Images } from '@nsw-paginas-deslogadas/assets'
import * as Utils from '@nsw-paginas-deslogadas/utils'
import * as S from './styles'

const BASE_URL = process.env.BASE_PUBLIC_URL

const Footer: FC = () => {
    const { Facebook, Instagram } = Images

    return (
        <S.Container>
            <Body mb={'0.625rem'} size={'sm'} sx={{ fontWeight: '600' }}>
                Você tem dúvidas?
            </Body>
            <Body mb={'0.625rem'} sx={S.StylizedParagraphs}>
                Entre em contato com meu time de atendimento pra receber a ajuda que precisa:
            </Body>

            <Flex sx={{ alignItems: 'flex-start' }}>
                <S.CustomIcon>
                    <Question />
                </S.CustomIcon>
                <Body fontSize={'14px'} fontWeight={700}>
                    Acesse nossa
                    <LinkInline
                        color="brand.primary.40"
                        href={`${Utils.CentralDeAjuda}`}
                        style={{ marginLeft: '5px', fontWeight: '400', fontSize: '14px' }}
                        target="_blank"
                        title="Ir para a Página de Central de Ajuda"
                    >
                        Central de Ajuda
                    </LinkInline>
                </Body>
            </Flex>

            <Flex sx={S.FlexLinksContainer}>
                <S.LinksContainer>
                    <LinkInline
                        color="brand.primary.40"
                        href="https://dasa.com.br/"
                        marginBottom={['1rem', '0.625rem']}
                        sx={S.FlexLinksChildren}
                        target="_blank"
                        title="Ir para o Site da Dasa"
                    >
                        Sobre a Dasa
                    </LinkInline>

                    <LinkInline
                        color="brand.primary.40"
                        href={`${Utils.NavConteudoLinkBuilded}`}
                        marginBottom={['1rem', '0.625rem']}
                        sx={S.FlexLinksChildren}
                        target="_blank"
                        title="Ir para o blog da Dasa"
                    >
                        Blog
                    </LinkInline>
                </S.LinksContainer>

                <S.LinksContainer>
                    <LinkInline
                        color="brand.primary.40"
                        href={`${BASE_URL}termos-de-uso`}
                        marginBottom={['1rem', '0.625rem']}
                        sx={S.FlexLinksChildren}
                        target="_blank"
                        title="Conhecer termos de uso"
                    >
                        Termos de Uso
                    </LinkInline>

                    <LinkInline
                        color="brand.primary.40"
                        href={`${BASE_URL}aviso-de-privacidade`}
                        marginBottom={['1rem', '0.625rem']}
                        sx={S.FlexLinksChildren}
                        target="_blank"
                        title="Conhecer aviso de privacidade"
                    >
                        Aviso de Privacidade
                    </LinkInline>
                </S.LinksContainer>

                <S.LinksContainer>
                    <LinkInline
                        color="brand.primary.40"
                        href={`${Utils.IosAppLinkBuilded}`}
                        marginBottom={['1rem', '0.625rem']}
                        sx={S.FlexLinksChildren}
                        target="_blank"
                        title="Fazer o download para IOS"
                    >
                        Baixe o app para IOS
                    </LinkInline>
                    <LinkInline
                        color="brand.primary.40"
                        href={`${Utils.AndroidAppLinkBuilded}`}
                        sx={S.FlexLinksChildren}
                        target="_blank"
                        title="Fazer o download para Android"
                    >
                        Baixe o app para Android
                    </LinkInline>
                </S.LinksContainer>
            </Flex>

            <Flex sx={S.FlexLinksImages}>
                <LinkInline href={`${Utils.FacebookDasa}`} target="_blank" title="Visite nosso Facebook">
                    <img alt={Facebook.alt} src={Facebook.src} />
                </LinkInline>
                <LinkInline href={`${Utils.InstagramDasa}`} marginLeft={'1.125rem'} target="_blank" title="Visite nosso Instagram">
                    <img alt={Instagram.alt} src={Instagram.src} />
                </LinkInline>
            </Flex>
        </S.Container>
    )
}

export default Footer
